export const PLAID_LINK_ERROR_CODES = [
    'RATE_LIMIT',
    'INSTITUTION_DOWN',
    'INSTITUTION_NOT_RESPONDING',
    'INSTITUTION_NO_LONGER_SUPPORTED',
    'INVALID_CREDENTIALS',
    'INVALID_MFA',
    'ITEM_LOCKED',
    'USER_SETUP_REQUIRED',
    'TOO_MANY_VERIFICATION_ATTEMPTS',
    'INTERNAL_SERVER_ERROR'
];
export const UNKNOWN_PLAID_LINK_ERROR_CODE = 'UNKNOWN';
export var PaymentMethodAddStalledOutcome = /*#__PURE__*/ function(PaymentMethodAddStalledOutcome) {
    PaymentMethodAddStalledOutcome["Rescued"] = "rescued";
    PaymentMethodAddStalledOutcome["GaveUp"] = "gaveUp";
    return PaymentMethodAddStalledOutcome;
}({});
export const IDENTITY_MISMATCH_RELOAD_TRIGGERS = [
    'pageRestored',
    'becameVisible'
];
export const UNKNOWN_IDENTITY_MISMATCH_RELOAD_TRIGGER = 'unknown';
